import { FiChevronDown } from "react-icons/fi";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { LuHistory } from "react-icons/lu";
import { LiaEdit } from "react-icons/lia";
import axios from "axios";
import { getChatHistoryList } from "../../api/chatApi";

const StaggeredDropDown = () => {
  const [open, setOpen] = useState(false);
  const [historyDivs, setHistoryDivs] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getChatHistoryList();
        setHistoryDivs(response.data);
      } catch (error) {
        console.error("Failed to fetch chat history:", error);
      }
    }

    fetchData();
  }, []);

  return (
    <motion.div animate={open ? "open" : "closed"} className="relative ">
      <button onClick={() => setOpen((pv) => !pv)} className=" text-white">
        <div className="flex justify-center py-1">
          <LuHistory style={{ fontSize: "24px" }} />
        </div>

        <div className="flex justify-center items-center gap-1 md:gap-2">
          <h6 className="text-sm md:text-xl">History</h6>
          <motion.span variants={iconVariants}>
            <FiChevronDown />
          </motion.span>
        </div>
      </button>

      <motion.ul
        initial={wrapperVariants.closed}
        variants={wrapperVariants}
        style={{ originY: "top", translateX: "-50%" }}
        className="py-4 rounded-lg bg-darkPurple absolute top-[120%] left-[62%] w-screen h-100 md:h-screen  overflow-auto"
      >
        <div className="grid grid-cols-1 gap-4 px-4">
          {historyDivs.map((item) => (
            <motion.li
              key={item.session_id}
              variants={itemVariants}
              onClick={() => setOpen(false)}
              className=" text-sm md:text-xl text-white cursor-pointer"
            >
              <button
                key={item.session_id}
                className="flex justify-between items-center gap-2 border border-greenColorLight p-3 rounded-xl w-full"
              >
                <h6>{item.message.slice(0, 40)}...</h6>
                <span className=" text-lg md:text-2xl mb-1">
                  <LiaEdit />
                </span>
              </button>
            </motion.li>
          ))}
        </div>
      </motion.ul>
    </motion.div>
  );
};

export default StaggeredDropDown;

const wrapperVariants = {
  open: {
    scaleY: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
  closed: {
    scaleY: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
    },
  },
};

const iconVariants = {
  open: { rotate: 180 },
  closed: { rotate: 0 },
};

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: {
      when: "beforeChildren",
    },
  },
  closed: {
    opacity: 0,
    y: -15,
    transition: {
      when: "afterChildren",
    },
  },
};
